<template>
  <div v-loading="loading">
    <div class="detail_echart_top">
      <div
        class="detail_top_item"
        v-for="(item, index) in gridList"
        :key="index"
      >
        <div class="detail_top_item_title">{{ item.value | FormatNum }}</div>
        <div class="detail_top_item_value">{{ item.label }}</div>
      </div>
    </div>
    <div class="detail_echart_table">
      <div class="table_header">
        <div class="table_header_title">
          {{ $t("Relationship.Management") }}
        </div>
      </div>
      <div class="detail_table_body">
        <el-table
          class="risk_table"
          :data="tableData"
          height="100%"
          ref="tableRef"
          :row-key="(row) => row.aaaId"
        >
          <el-table-column
            prop="name"
            :label="$t('Relationship.Name')"
            min-width="200"
          >
            <template v-slot:header>
              <div
                class="table_header_search_title"
                @click="isSearchCompany = false"
                v-if="isSearchCompany"
              >
                {{ $t("Relationship.Name") }}
                <i class="iconfont icon-jiantouxia" />
              </div>
              <el-select
                v-else
                style="width: 100%"
                clearable
                filterable
                class="table_header_search"
                popper-class="new-search-select"
                :placeholder="$t('Relationship.Pleaseentername')"
                v-model="filterName"
                @change="(val) => filterSearch(val)"
              >
                <el-option
                  v-for="(item, index) in tableData"
                  :key="index"
                  :value="item.name"
                  :label="item.name"
                />
              </el-select>
            </template>
            <template slot-scope="scope">
              <div class="flex_center_start_box">
                <span
                  :class="
                    Number(scope.row.relations) > 0 ? 'link_hover_text' : ''
                  "
                  @click="
                    Number(scope.row.relations) > 0
                      ? searchDetails(scope.row)
                      : ''
                  "
                >
                  {{ scope.row.name }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="country"
            align="center"
            :label="$t('Relationship.Country')"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="position"
            align="center"
            :label="$t('Relationship.Position')"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="department"
            :label="$t('Relationship.Department')"
            align="center"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            :label="$t('Relationship.Phone')"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="email"
            align="center"
            :label="$t('Relationship.Email')"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="shareholder"
            align="center"
            :label="$t('Relationship.ShareholderorNot')"
            min-width="160"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop=""
            align="center"
            :label="$t('Relationship.Relations')"
            min-width="90"
          >
            <template slot-scope="scope">
              <i
                slot="reference"
                class="iconfont icon-search"
                :disabled="scope.row.relations == 0"
                @click="
                  Number(scope.row.relations) > 0
                    ? searchDetails(scope.row)
                    : ''
                "
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <Page
          keyword="Management"
          :fontColor="'#B44818'"
          :total="total"
          :pageSize="searchParams.pageSize"
          :currentPage="searchParams.currentPage"
          @onPageChange="onChangePage"
        ></Page>
      </div>
    </div>
    <div class="detail_echart_table" v-if="tableDataDetail.entname != ''">
      <div class="table_header_title margin-bottom20">
        {{ tableDataDetail.entname }}
        <i class="iconfont icon-cuowu" @click="closeDetailTable" />
      </div>
      <div class="detail_table_body">
        <el-table
          class="risk_table"
          :data="tableDataDetail.childrens"
          height="100%"
          ref="tableRef"
          :row-key="(row) => row.aaaId"
        >
          <el-table-column
            prop="companyName"
            :label="$t('Relationship.CompanyName')"
            min-width="200"
          >
            <template slot-scope="scope">
              <div class="flex_center_start_box">
                <!-- <span class="link_hover_text" @click="goDetail(scope.row)">
                  {{ scope.row.companyName }}</span
                > -->
                <span
                  class="link_hover_text"
                  v-if="
                    scope.row.id3a
                      .split('')
                      .every((char) => char >= '0' && char <= '9')
                  "
                  @click="goDetail(scope.row)"
                >
                  {{ scope.row.name }}</span
                >
                <span v-else>
                  {{ scope.row.name }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="companyType"
            :label="$t('Relationship.Type')"
            align="center"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="country"
            align="center"
            :label="$t('Relationship.Country')"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="relations"
            align="center"
            :label="$t('Relationship.Relations')"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <Page
          :keyword="$t('Relationship.Management')"
          :fontColor="'#B44818'"
          :total="totalDetail"
          :pageSize="searchParams.pageDetailSize"
          :currentPage="searchParams.currentDetailPage"
          @onPageChange="onChangeDetailPage"
        ></Page>
      </div>
    </div>
    <Tips :dialogVisible.sync="isShowTips"></Tips>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import Page from "@/views/newLayout/page.vue";
import EquityD3 from "@/views/company/details/Background/componet/index.vue";
import RelationshipD3 from "./Com_Relationship-d3.vue";
import Tips from "@/views/newLayout/tips.vue";
import {
  getCompanyManagement,
  getPersonRelateCompany,
  getManagementSummary,
} from "@/api/companyApi";
import {
  formatterTxt,
  formatListMax50,
} from "@/views/company/details/Background/utils";

export default {
  name: "UboDetail5",
  mixins: [mixins1],
  components: {
    Page,
    EquityD3,
    Tips,
    RelationshipD3,
  },
  data() {
    return {
      loading: false,
      isShowTips: false,
      isShowD3: false,
      isSearchCompany: true,
      total: 0,
      totalDetail: 0,
      searchParams: {
        currentPage: 1,
        pageSize: 5,
        currentDetailPage: 1,
        pageDetailSize: 5,
      },
      gridList: [
        { label: this.$t("Relationship.Management"), value: "-" },
        { label: this.$t("Relationship.ContactInfo"), value: "-" },
        { label: this.$t("Relationship.Countries"), value: "-" },
      ],
      filterName: "",
      tableData: [],
      //数据留存
      tableDataCopy: [],
      tableDataDetail: {
        entname: "",
        pid: "",
        childrens: [],
      },
    };
  },
  methods: {
    changeSwitch(val) {
      this.isShowD3 = val;
    },
    onChangePage(param) {
      this.closeDetailTable();
      this.searchParams.currentPage = param.page;
      this.searchParams.pageSize = param.pageSize;
      this.getCompanyManagement();
    },
    onChangeDetailPage(param) {
      this.searchParams.currentDetailPage = param.page;
      this.searchParams.pageDetailSize = param.pageSize;
      this.getCompanyManagement();
    },
    // 跳转ubo详细
    goDetail(row) {
      let routeData = this.$router.resolve({
        path: "/ubo/detail",
        query: {
          id3a: row.id3a,
          keyword: row.companyName,
          selectKey: "Company",
        },
      });
      window.open(routeData.href, "_blank");
    },
    //检索
    filterSearch(val) {
      if (val) {
        this.tableData = this.tableDataCopy.filter((list) => list.name == val);
      } else {
        this.tableData = this.tableDataCopy;
      }
    },
    //股东关系
    searchDetails(row) {
      // this.tableDataDetail = row;
      this.tableDataDetail.pid = row.pid;
      this.tableDataDetail.entname = row.entname;
      let param = {
        id3a: this.$route.query.id3a,
        pid: this.tableDataDetail.pid,
        page: this.searchParams.currentDetailPage,
        pageSize: this.searchParams.pageDetailSize,
      };
      getPersonRelateCompany(param)
        .then((res) => {
          if (res.code == 200) {
            this.tableDataDetail.childrens = res.data.rows;
            this.totalDetail = res.data.total;
          }
        })
        .catch((err) => {});
      this.$nextTick(() => {
        document.querySelector(".content_wrap").scrollTop = 9999;
      });
    },
    // 关闭
    closeDetailTable() {
      this.tableDataDetail = {
        entname: "",
        pid: "",
        childrens: [],
      };
    },
    getCompanyManagement() {
      let param = {
        id3a: this.$route.query.id3a,
        email: this.searchParams.email,
        positionCode: this.searchParams.positionCode,
        countryCode: this.searchParams.countryCode,
        page: this.searchParams.currentPage,
        pageSize: this.searchParams.pageSize,
      };
      getCompanyManagement(param)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.rows;
            this.tableDataCopy = res.data.rows;
            this.total = res.data.total;
          }
        })
        .catch((err) => {});
    },
    getRelatedSummaryList() {
      const id3a = this.$route.query.id3a;
      getManagementSummary({ id3a: id3a }).then((res) => {
        if (res.code == 200) {
          this.gridList = [
            {
              label: this.$t("Relationship.Management"),
              value: res.data.employees || "-",
            },
            {
              label: this.$t("Relationship.ContactInfo"),
              value: res.data.contacts || "-",
            },
            {
              label: this.$t("Relationship.Countries"),
              value: res.data.countries || "-",
            },
          ];
        }
      });
    },
  },
  mounted() {
    this.getCompanyManagement();
    this.getRelatedSummaryList();
  },
};
</script>
<style scoped>
.icon-search {
  font-size: 30px;
  color: #b44818;
  cursor: pointer;
}
.icon-search[disabled] {
  color: #999999;
  cursor: not-allowed;
}
.icon-cuowu {
  float: right;
  color: #1a2332;
  font-size: 26px;
  cursor: pointer;
}
.table_header_search_title {
  cursor: pointer;
  padding-left: 9px;
  padding-right: 9px;
  font-family: "Arial Bold";
  font-size: 18px !important;
  color: #1a2332;
  line-height: 24px;
  font-style: normal;
}
.table_header_search_title i {
  color: #b44818;
}
.risk_table >>> .el-table__body-wrapper {
  height: 100% !important;
}

.detail_echart_table {
  display: flex;
  flex-direction: column;
}

.detail_table_body {
  flex: 1;
  min-height: 0;
}

.pagination_box {
  margin-top: auto;
}

.detail_echart_table {
  min-height: calc(100vh - 462px);
}

.table_header_title {
  color: rgb(96, 60, 44);
}
@media (max-width: 1920px) {
  .icon-search {
    font-size: 24px;
  }
  .icon-cuowu {
    font-size: 22px;
  }
  .table_header_search_title {
    padding-left: 7px;
    padding-right: 7px;
    font-size: 16px !important;
    line-height: 20px;
  }
  .table_header_search ::v-deep .el-input--suffix {
    height: 36px;
  }
  .detail_echart_table {
    min-height: calc(100vh - 394px);
  }
}
</style>
